export default {
  name: 'Image & Text',
  bigImgName: 'Full Image',
  leftImgName: 'Image On Left',
  rightImgName: 'Image On Right',
  crossedImgName: 'Imag&Text',
  topImgName: 'Columns',
  label: {
    hideItemMargin: 'Hide Component Spacing',
    alignTop: 'Top',
    alignCenter: 'Center',
    alignBottom: 'Bottom'
  }
}
